import React, { createContext, useContext, useMemo } from "react";

import * as patchingTemplateServices from "./services/admin/patchingTemplateServices";
import * as accountServices from "./services/admin/accountServices";
import * as auditLogServices from "./services/admin/auditLogServices";

export const AdminContext = createContext();

const AdminProvider = ({ children }) => {
  const api = useMemo(
    () => ({
      patchingTemplateServices,
      accountServices,
      auditLogServices,
    }),
    [],
  );

  return <AdminContext.Provider value={api}>{children}</AdminContext.Provider>;
};

export const useAdminContext = () => useContext(AdminContext);

export default AdminProvider;
